import { get } from '@/api'
import { loadItemData } from '@/utils/api/index'
import { removeRootPathFromUri } from '@/utils'

export async function loadAssayData(id) {
  return loadItemData(id, { appName: 'assays', modelName: 'assays' })
}

const DM_DATASETS_URL = 'data_management/datasets/'

/**
 * Load datasets data for a specific assay
 * @param {Object} options Options containing query parameters
 * @returns {Promise<Array>} Array of dataset objects
 */

export async function loadDatasets({ queryParameters = {} }) {
  let datasetsData = []
  let getDatasetsUrl = DM_DATASETS_URL
  let qParams = new URLSearchParams(queryParameters)
  qParams = qParams.toString()
  if (qParams) getDatasetsUrl += `?${qParams}`
  try {
    const response = await get(getDatasetsUrl)
    if (response.status === 200) {
      datasetsData = response.data.results
    }
  } catch (e) {
    console.error('Could not load datasets', e)
  }
  return datasetsData
}

/**
 * Load datasets data for a specific assay
 * @param {string} id Assay ID
 * @returns {Promise<Array>} Array of dataset objects
 */
export async function loadAssayDatasets(id) {
  return loadDatasets({ queryParameters: { assay: id } })
}

/**
 * Fetch dropboxes with optional parameters
 * @param {URLSearchParams|null} params Optional query parameters
 * @returns {Promise<Array>} Array of dropbox objects with computed relative paths
 */
export async function fetchDropboxes(params = null) {
  // let dropboxes = []
  let getDropboxUrl = 'data_management/dropbox/'
  const paramsStr = new URLSearchParams(params || {}).toString()
  if (paramsStr) getDropboxUrl += `?${paramsStr}`
  // try {
  const { data: dropboxes } = await get(getDropboxUrl)
  return dropboxes
}

export async function fetchFolderContent(folder, options = {}) {
  const { fetchContentUrl, relativePath } = folder
  const { recursive = false, extension = null } = options

  let getContentUrl = `${fetchContentUrl}${relativePath}`

  // add query params for recursive-listing and file-extension filtering
  const params = new URLSearchParams()
  if (recursive) {
    params.set('recursive', 'true')
  }
  if (extension) {
    params.set('extension', extension)
  }

  const paramsStr = params.toString()
  if (paramsStr) {
    getContentUrl += `&${paramsStr}`
  }

  const { data: folderContent } = await get(getContentUrl)
  return folderContent
}

export async function getDropboxFolderContent(dropbox, folder, options = {}) {
  const { path: dropboxRoot, fetchContentUrl } = dropbox
  folder.fetchContentUrl = fetchContentUrl
  const folderContent = await fetchFolderContent(folder, options)
  return folderContent.map((f) => {
    const id = f.id || f.uri
    return { ...f, id, relativePath: removeRootPathFromUri(dropboxRoot, f.uri) }
  })
}
